import { Link } from "react-router-dom"
import "../css/mobilehomepage.css"
import { useEffect } from "react";

export default function MobileHomePage() {

    useEffect(() => {
        document.body.classList.add("home-bg");
        return () => document.body.classList.remove("home-bg"); // 페이지 벗어나면 제거
    }, []);

    const handleBack = () => {
        // 토큰 완전 삭제
        localStorage.removeItem("accessToken");

        localStorage.setItem("autoLogin", "false");

        // 뒤로가기 (히스토리가 없으면 로그인으로)
        if (window.history.length > 1) window.history.back();
        else window.location.assign("/");
    };

    const handleLogout = () => {
        localStorage.removeItem("accessToken");

        localStorage.setItem("autoLogin", "false");

        window.location.assign("/")
    }

    return (
        <>
            <nav className="Nav_MobileHomePage">
                <div>
                    <button className="back_button_home"
                        type="button"
                        onClick={handleBack}
                        style={{ background: "none", border: "none", cursor: "pointer", height: "60px" }}
                        aria-label="뒤로가기"
                    >
                        <svg width="22" height="22" viewBox="0 0 24 24">
                            <path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <div>
                        <Link to="/mydatelist"><button>마이페이지</button></Link>
                        <button onClick={handleLogout}>로그아웃</button>
                    </div>
                </div>
                <div>
                    <img src="/images/GuardianFieldmaster_white.png" width="280px" height="80px"></img>
                </div>
                <div>안전 스마트 일지</div>
                <div>(Safety Log Book)</div>
                <div>
                    <Link to="/insert"><button><p>작성하기</p><p>(Check Now)</p></button></Link>
                    <Link to="/datelist"><button><p>목록보기</p><p>(View List)</p></button></Link>
                </div>
            </nav>
        </>
    )
}